export const apiPath = '/v1/client_credentials';
const actionType = 'CLIENT_CREDENTIAL';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
